import React from "react";
import {
  Title,
  Text,
  Card,
  SimpleGrid,
  Container,
  rem,
  Button,
} from "@mantine/core";
import {
  IconSalad,
  IconRun,
  IconCalendar,
  IconMessageCircle,
  IconChartBar,
  IconBook,
  IconReportAnalytics,
} from "@tabler/icons-react";
import { scroller } from "react-scroll";
import classes from "./features.module.scss";
import "./styles.scss";

const data = [
  {
    title: "Grundig analyse",
    description:
      "Basert på introduksjonsmøtet og et omfattende spørreskjema kartlegger jeg din nåværende situasjon i detalj — kosthold, trening, søvn, helse og livsstil.",
    icon: IconReportAnalytics,
  },
  {
    title: "Kostholdsplan",
    description:
      "Ikke en streng diett, men et rammeverk du kan leve etter. Du lærer å velge sunnere — uten å gi opp maten du elsker.",
    icon: IconSalad,
  },
  {
    title: "Treningsprogram",
    description:
      "Et program skreddersydd deg, der målet er at treningen blir enkel å gjennomføre og faktisk gøy å holde på med.",
    icon: IconRun,
  },
  {
    title: "Ukentlig oppfølging",
    description:
      "Hver uke går vi gjennom progresjonen din og justerer planen underveis, så du alltid vet at du er på rett vei.",
    icon: IconCalendar,
  },
  {
    title: "Månedlig gjennomgang",
    description:
      "En grundig gjennomgang av reisen så langt. Alt dokumenteres, og vi finjusterer planen for en bærekraftig neste måned.",
    icon: IconChartBar,
  },
  {
    title: "Fri kommunikasjon",
    description:
      "Dukker det opp spørsmål mellom møtene? Send en melding når som helst, så svarer jeg så fort jeg kan.",
    icon: IconMessageCircle,
  },
  {
    title: "Tilgang til informasjonsportal",
    description:
      "Pålitelig helsekunnskap fra gode kilder, samlet på ett sted og formulert så det er enkelt å forstå.",
    icon: IconBook,
    comingSoon: true,
  },
];

export function FeaturesComponent() {
  const handleButtonClick = () => {
    scroller.scrollTo("contact", {
      duration: 800,
      smooth: "easeInOutQuart",
      offset: -70,
    });
  };

  const features = data.map((feature) => (
    <Card
      key={feature.title}
      shadow="md"
      radius="md"
      className={classes.card}
      padding="xl"
    >
      {feature.comingSoon && (
        <div className={classes.comingSoonBadge}>Kommer snart</div>
      )}
      <feature.icon
        style={{ width: rem(48), height: rem(48) }}
        stroke={2}
        color="#20c997"
      />
      <Text fz="lg" fw={600} className={classes.cardTitle} mt="md">
        {feature.title}
      </Text>
      <Text fz="sm" c="dimmed" mt="sm" className={classes.cardDescription}>
        {feature.description}
      </Text>
    </Card>
  ));

  return (
    <section className="section-pad">
      <Container size="lg">
        <div className={classes.header}>
          <span className={classes.eyebrow}>Hva du får</span>
          <Title order={2} className={classes.title}>
            Alt du trenger — i én månedlig plan
          </Title>
        </div>
        <SimpleGrid cols={{ base: 1, md: 3 }} spacing="xl" mt={50}>
          {features}
        </SimpleGrid>
        <div className={classes.ctaWrapper}>
          <Button
            variant="gradient"
            gradient={{ from: "teal", to: "green" }}
            size="xl"
            radius="xl"
            className={classes.control}
            onClick={handleButtonClick}
            aria-label="Start din treningsreise"
          >
            Kom i gang!
          </Button>
        </div>
      </Container>
    </section>
  );
}
